export default __webpack_public_path__ + "static/media/login_bg.938ca4ac.png";